var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaddle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 56 57",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1741_6116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.2096 31.969C39.7769 31.969 35.0599 35.092 32.7827 39.6464L7.57098 14.4347L7.63605 14.3696L14.1531 7.85254C23.6414 -1.63574 39.0179 -1.63574 48.5061 7.85254C55.7823 15.1287 57.4739 25.8857 53.581 34.7776C51.2605 33.01 48.3543 31.969 45.2096 31.969ZM5.44561 17.2107L31.5574 43.3224C31.4055 44.1357 31.3296 44.9815 31.3296 45.849C31.3296 48.3648 32.002 50.7179 33.1622 52.7565C32.8369 52.7782 32.5008 52.789 32.1646 52.789H31.8718C28.1958 52.789 24.6607 51.3251 22.0582 48.7226L20.9955 47.6599C19.575 46.2394 17.2436 46.3153 15.9207 47.8443L9.66383 55.0662C9.03489 55.7928 8.12401 56.2265 7.16976 56.259C6.21551 56.2916 5.27211 55.9229 4.58895 55.2397L1.11895 51.7697C0.435797 51.0866 0.0671091 50.154 0.0996403 49.1998C0.132172 48.2455 0.565922 47.3346 1.29245 46.7057L8.51439 40.4489C10.0325 39.1259 10.1193 36.7945 8.69873 35.374L7.63605 34.3113C5.03355 31.6979 3.56964 28.1629 3.56964 24.4869V24.1941C3.56964 21.7217 4.23111 19.3252 5.44561 17.2215V17.2107ZM45.2096 35.439C47.9705 35.439 50.6184 36.5358 52.5706 38.4881C54.5229 40.4403 55.6196 43.0881 55.6196 45.849C55.6196 48.6099 54.5229 51.2578 52.5706 53.21C50.6184 55.1623 47.9705 56.259 45.2096 56.259C42.4487 56.259 39.8009 55.1623 37.8487 53.21C35.8964 51.2578 34.7996 48.6099 34.7996 45.849C34.7996 43.0881 35.8964 40.4403 37.8487 38.4881C39.8009 36.5358 42.4487 35.439 45.2096 35.439Z",
    fill: "#38b001"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1741_6116",
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55.52,
    height: 55.52,
    fill: "white",
    transform: "translate(0.101562 0.739258)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaddle);
export default __webpack_public_path__ + "static/media/paddle.4133d36c0f6c8d5179d6e42683898358.svg";
export { ForwardRef as ReactComponent };